<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-document-checked"></i> {{$t('pages.mtOutputYearQuery.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container" v-loading="loading">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.mtStd.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.mtStd.export')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.StartYear" type="year" :placeholder="$t('pages.mtStd.yearStartPh')" class="handle-date mr10"></el-date-picker>
                <el-date-picker v-model="query.EndYear" type="year" :placeholder="$t('pages.mtStd.yearEndPh')" class="handle-date mr10"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.mtStd.mine')" class="handle-select mr10">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.mtStd.search')}}</el-button>
            </div>
        </div>

        <!-- MT1082-2008 表6 产量按年查询显示（横向标准表样） -->
        <el-table :data="rows" border class="table" id="mytable" header-cell-class-name="table-header" :height="tableHeight">
            <el-table-column type="index" :label="$t('pages.mtStd.index')" width="60" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('pages.mtStd.mine')" min-width="140"></el-table-column>
            <el-table-column prop="annualCapacity" :label="$t('pages.mtStd.annualCapacity')" width="110" align="center"></el-table-column>
            <el-table-column prop="monthCapacity" :label="$t('pages.mtStd.monthCapacity')" width="140" align="center"></el-table-column>
            <el-table-column prop="unit" :label="$t('pages.mtStd.unit')" width="55" align="center"></el-table-column>
            <el-table-column :label="yearOutLabel()" min-width="110" align="center">
                <template slot-scope="scope">
                    <span :class="{ red: isOver(scope.row.yearOutputCnb) }">{{ scope.row.yearOutputCnb }}</span>
                </template>
            </el-table-column>
            <el-table-column v-for="n in 12" :key="'m' + n" :label="monthLabel(n)" min-width="110" align="center">
                <template slot-scope="scope">
                    <span :class="{ red: isOver(scope.row.months[n - 1]) }">{{ scope.row.months[n - 1] }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'mtOutputYearQuery',
    data: function () {
        return {
            loading: false,
            tableHeight: window.innerHeight * 0.75,
            isDisplayCompanyName: false,
            balanceArr: [],
            yearRows: [],
            monthMap: {},
            rows: [],
            annualCapacity: null,
            monthlyCapacity: null,
            sy: null,
            ey: null,
            query: {
                StartYear: '',
                EndYear: '',
                balanceId: 0
            }
        };
    },
    created() {
        this.query.StartYear = new Date();
        this.query.EndYear = new Date();
        this.getBalance();
        this.getData();
    },
    methods: {
        yearOutLabel() {
            return this.$t('pages.mtStd.yearOutput') + '\\' + this.$t('pages.mtStd.cnb');
        },
        monthLabel(n) {
            return n + this.$t('pages.mtStd.monthUnit') + this.$t('pages.mtStd.output') + '\\' + this.$t('pages.mtStd.cnb');
        },
        fmtMonth(d) {
            if (!d) return '--';
            var dt = new Date(d);
            return isNaN(dt.getTime()) ? '--' : dateFormat.formatDate(dt, 'yyyy-MM');
        },
        fmtYear(d) {
            if (!d) return '--';
            var dt = new Date(d);
            return isNaN(dt.getTime()) ? '--' : dateFormat.formatDate(dt, 'yyyy');
        },
        getData() {
            if (!this.query.StartYear || !this.query.EndYear) {
                this.$notify.warning(this.$t('pages.mtStd.yearStartPh'));
                return;
            }
            var sy = new Date(this.query.StartYear).getFullYear();
            var ey = new Date(this.query.EndYear).getFullYear();
            if (sy > ey) {
                this.$notify.warning(this.$t('pages.mtStd.rangeError'));
                return;
            }
            this.sy = sy;
            this.ey = ey;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            var balanceId = this.query.balanceId;
            this.loading = true;
            this.$zybhttp
                .post('ProdInquiry/YearData', {
                    StatrtYear: sy,
                    EndYear: ey,
                    userName: userInfo.realName,
                    balanceId: balanceId,
                    createUserId: userInfo.id,
                    PageIndex: 1,
                    PageSize: 1000
                })
                .then((res) => {
                    if (res.data.status != 0) throw { handled: true, message: res.message };
                    this.isDisplayCompanyName = res.data.info1 == '是';
                    this.yearRows = (res.data.data && res.data.data.list) || [];
                    return this.$zybhttp.post('ProdInquiry/MonthData', {
                        StartMonth: sy + '-01',
                        EndMonth: ey + '-12',
                        balanceId: balanceId,
                        CreateUserId: userInfo.id,
                        UserName: userInfo.realName,
                        PageIndex: 1,
                        PageSize: 5000
                    });
                })
                .then((res) => {
                    if (res.data.status != 0) throw { handled: true, message: res.message };
                    var map = {};
                    ((res.data.data && res.data.data.list) || []).forEach((m) => {
                        var bid = m.balanceId != null ? m.balanceId : '--';
                        map[bid + '|' + this.fmtMonth(m.date)] = m;
                    });
                    this.monthMap = map;
                    return this.$zybhttp.get('OverproductionQuery/YearCCData', {
                        params: {
                            balanceId: balanceId,
                            Year: ey,
                            CreateUserId: userInfo.id,
                            UserName: userInfo.realName
                        }
                    });
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.status == 0) {
                        this.annualCapacity = res.data.info1;
                        this.monthlyCapacity = res.data.info2;
                    }
                    this.buildRows();
                })
                .catch((e) => {
                    this.loading = false;
                    if (e && e.handled) this.$notify.error(e.message);
                    else this.$notify.error(this.$t('pages.mtStd.fetchError'));
                });
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 == '是';
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.mtStd.all'),
                            fullName: this.$t('pages.mtStd.all')
                        }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => this.$notify.error(this.$t('pages.mtStd.fetchError')));
        },
        // 生成标准表6行：煤矿|年生产能力|月生产能力|单位|年产量\产能比|1~12月产量\产能比
        buildRows() {
            var nameField = this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName';
            var bids = {};
            var list = this.yearRows.map((it) => {
                if (it.balanceId != null) bids[it.balanceId] = true;
                var year = this.fmtYear(it.date);
                var bid = it.balanceId != null ? it.balanceId : '--';
                var months = [];
                for (var m = 1; m <= 12; m++) {
                    var key = bid + '|' + year + '-' + (m < 10 ? '0' + m : m);
                    var cell = this.monthMap[key];
                    months.push(cell ? this.nz(cell.weight) + '\\' + this.fmtCnb(cell.monthCNB) : '--');
                }
                return {
                    name: it[nameField] || it.balanceName || '--',
                    sortBid: it.balanceId != null ? it.balanceId : 999999,
                    year: year,
                    yearOutputCnb: this.nz(it.weight) + '\\' + this.fmtCnb(it.yearCNB),
                    months: months
                };
            });
            list.sort((a, b) => (a.sortBid - b.sortBid) || (a.year < b.year ? -1 : a.year > b.year ? 1 : 0));
            // 单矿（或仅一组）时才展示汇总的生产能力；多矿模式下接口仅返回合计，逐行展示会造成歧义
            var singleMine = Object.keys(bids).length <= 1;
            this.rows = list.map((r) => {
                return {
                    name: r.name,
                    annualCapacity: singleMine ? this.nz(this.annualCapacity) : '--',
                    monthCapacity: singleMine ? this.nz(this.monthlyCapacity) : '--',
                    unit: this.$t('pages.mtStd.unitT'),
                    yearOutputCnb: r.yearOutputCnb,
                    months: r.months
                };
            });
        },
        // CNB 归一化：数值>10 视为百分数（90→90%），<=10 视为小数比率（0.9→90%），含%字符串直接使用
        fmtCnb(v) {
            if (v === null || v === undefined || v === '') return '--';
            var s = String(v).trim();
            if (s.indexOf('%') > -1) {
                var pv = parseFloat(s.replace('%', ''));
                return isFinite(pv) ? this.oneDecimal(pv) + '%' : '--';
            }
            var n = parseFloat(s);
            if (!isFinite(n)) return '--';
            var p = n > 10 ? n : n * 100;
            return this.oneDecimal(p) + '%';
        },
        fmtPct(p) {
            return isFinite(p) ? this.oneDecimal(p) + '%' : '--';
        },
        oneDecimal(p) {
            var r = Math.round(p * 10) / 10;
            return Number.isInteger(r) ? r.toFixed(0) : r.toFixed(1);
        },
        isOver(cell) {
            if (!cell) return false;
            var parts = String(cell).split('\\');
            if (parts.length < 2) return false;
            var p = parseFloat(parts[1]);
            if (!isFinite(p)) return false;
            var ratio = p > 10 ? p / 100 : p;
            return ratio > 1; // 产能比大于100%标红（标准5.5.5.3）
        },
        nz(v) {
            return v === null || v === undefined || v === '' ? '--' : v;
        },
        printlist() {
            var sy = this.sy || new Date().getFullYear();
            var ey = this.ey || new Date().getFullYear();
            var props = [{
                    field: 'index',
                    displayName: this.$t('pages.mtStd.index'),
                    columnSize: '4%'
                },
                {
                    field: 'name',
                    displayName: this.$t('pages.mtStd.mine'),
                    columnSize: '10%'
                },
                {
                    field: 'annualCapacity',
                    displayName: this.$t('pages.mtStd.annualCapacity'),
                    columnSize: '8%'
                },
                {
                    field: 'monthCapacity',
                    displayName: this.$t('pages.mtStd.monthCapacity'),
                    columnSize: '9%'
                },
                {
                    field: 'unit',
                    displayName: this.$t('pages.mtStd.unit'),
                    columnSize: '4%'
                },
                {
                    field: 'yearOutputCnb',
                    displayName: this.yearOutLabel(),
                    columnSize: '9%'
                }
            ];
            var data = this.rows.map((r, i) => {
                var o = {
                    index: i + 1,
                    name: r.name,
                    annualCapacity: r.annualCapacity,
                    monthCapacity: r.monthCapacity,
                    unit: r.unit,
                    yearOutputCnb: r.yearOutputCnb
                };
                for (var n = 1; n <= 12; n++) {
                    o['m' + n] = r.months[n - 1];
                    props.push({
                        field: 'm' + n,
                        displayName: this.monthLabel(n),
                        columnSize: '6%'
                    });
                }
                return o;
            });
            print({
                printable: data,
                header: `<div style="display: flex;flex-direction: column;text-align: center"><h3>${this.$t('pages.mtOutputYearQuery.printTitle')}（${sy}${this.$t('pages.mtStd.yearSuffix')}-${ey}${this.$t('pages.mtStd.yearSuffix')}）</h3></div>`,
                properties: props,
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.mtOutputYearQuery.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        }
    }
};
</script>

<style scoped>
.handle-select {
    width: 150px;
}

.handle-date {
    width: 140px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}
</style>
